import { Component } from '@angular/core';

@Component({
  selector: 'regions',
  templateUrl: './myregions.component.html',
})
export class MyRegionsComponent {
  constructor() {}
}
